import { css } from '@emotion/react';
import type { SerializedStyles } from '@emotion/react';
import { getBackgroundColorStyle } from './utils.styles';

export const getBackgroundColorOverride = (
  backgroundColorOverride?: string
): SerializedStyles | '' => {
  if (!backgroundColorOverride) return '';
  const bgStyle = getBackgroundColorStyle(backgroundColorOverride);
  return css`
    #public-wrapper {
      ${bgStyle}
      .home-page-hero.no-image {
        ${bgStyle}
      }
      .hero-wrapper .home-page-hero {
        .no-image {
          ${bgStyle}
        }
      }
      .sticky-nav {
        ${bgStyle}
        .pages-nav-container {
          ${bgStyle}
          .nav-container {
            ${bgStyle}
          }

          .list-inline > li a {
            ${bgStyle}
          }
        }
      }

      .events-actions__sticky-wrapper > div > div:nth-child(2) .events-actions {
        ${bgStyle}
      }

      #footer {
        ${bgStyle}
      }
    }
  `;
};
